import asyncRoute from '../../lib/asyncRoute';

export const Login = asyncRoute(() => import('./AuthLoginController'));
export const Find = asyncRoute(() => import('./AuthFindController'));
